/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Pick_PortalInputs */

const cs_pm_pick_portal = /** @type {(inputs: Pm_Pick_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Vyberte portál`)
};

const en_pm_pick_portal = /** @type {(inputs: Pm_Pick_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Pick a portal`)
};

/**
* | output |
* | --- |
* | "1. Pick a portal" |
*
* @param {Pm_Pick_PortalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_pick_portal = /** @type {((inputs?: Pm_Pick_PortalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Pick_PortalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_pick_portal(inputs)
	return cs_pm_pick_portal(inputs)
});